/* eslint-disable @typescript-eslint/ban-ts-comment */
// disable all ts errors in this file
// @ts-nocheck
// eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
// @ts-ignore

import { useTranslate } from '@tolgee/react';
import { Button, Modal } from 'react-bootstrap';
// eslint-disable-next-line prettier/prettier, @typescript-eslint/prefer-ts-expect-error
// @ts-ignore
import { useState } from 'react';
import { PLATFORM_STATIC_ICONS_PNG } from '../../../../config/icons';
import { INSTAGRAM } from '../../../../config/constants';
export default function ConnectInstagramModal(): JSX.Element {
  const { t } = useTranslate();
  const alreadyShown =
    window?.lomavisUserData?.userData?.communication_instagram_warning_shown;

  const [showHelpModal, setShowHelpModal] = useState(!alreadyShown);

  const onCloseButton = () => {
    setShowHelpModal(false);

    const csrftoken = (
      document.querySelector('[name=csrfmiddlewaretoken]') as HTMLInputElement
    ).value;

    fetch(`/api/v1/users/${window?.lomavisUserData?.userData?.userUuid}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': csrftoken // Include the CSRF token in the request headers
      },
      body: JSON.stringify({ communication_instagram_warning_shown: true }),
      credentials: 'include' // This line is added to include cookies in the request
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error('HTTP error ' + response.status);
        }
        return await response.json();
      })
      .then((json) => {
        console.log(json);
      })
      .catch(function () {
        console.log('An error occurred while fetching the data.');
      });
  };

  return (
    <Modal
      show={showHelpModal}
      onHide={() => {
        setShowHelpModal(false);
      }}
      centered
    >
      <Modal.Header className="border-0">
        <Modal.Title>
          {' '}
          <img
            src={PLATFORM_STATIC_ICONS_PNG[INSTAGRAM]}
            className="w-25px h-25px"
            style={{ marginRight: 2 }}
          />{' '}
          {t('lomavis_communication.ConnectInstagramModal.title')}
        </Modal.Title>
        <Button
          variant="outline-secondary"
          onClick={() => {
            onCloseButton();
          }}
        ></Button>
      </Modal.Header>
      <Modal.Body className="border-0">
        {t('lomavis_communication.ConnectInstagramModal.text')}
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => {
            onCloseButton();
          }}
        >
          {t('lomavis_communication.ConnectInstagramModal.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
